// extracted by mini-css-extract-plugin
module.exports = {"root":"PublicSamples_root__2qtya","heading":"PublicSamples_heading__1kBL2","text":"PublicSamples_text__2oFVd"};